import { render, staticRenderFns } from "./historicoCodigos.vue?vue&type=template&id=6a53d14f"
import script from "./historicoCodigos.vue?vue&type=script&lang=js"
export * from "./historicoCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports